// Dependencies
import React from 'react';

if (process.env.NODE_ENV !== 'test') {
  require('./HelpText.scss');
}

export default class extends React.Component {
  state = {
    // Must be null so first render can measure 100%.
    // Is the CURRENT height so we can trigger renders
    // with a given height.
    height: null,
    open: false,
  };

  // Should be considered a constant after being set,
  // represents the max height of the component.
  height = 0;

  shouldComponentUpdate({ open }, { height }) {
    return open !== this.props.open || height !== this.state.height;
  }

  componentWillReceiveProps({ open }) {
    if (open == null) return;

    if (open) {
      this.openDrawer();
    } else {
      this.closeDrawer();
    }
  }

  openDrawer = () => {
    this.setState({ open: !this.state.open });
  };

  closeDrawer = () => {
    this.setState({ open: !this.state.open });
  };

  render() {
    return (
      <div className="HelpText">
        <div
          className={
            this.state.open
              ? 'drawer-content-wrapper open'
              : 'drawer-content-wrapper'
          }
        >
          <div className="drawer-content">{this.props.children}</div>
        </div>
      </div>
    );
  }
}
